@if (showTestBanner) {
  <app-test-banner position="top-right"/>
}
<div class="step-container">
  <app-header/>
  <section>
    @if (s.currentStep() > 0) {
      @switch (s.currentStep()) {
        @case (s.stepsData.rentalPointsSelection.step) {
          <app-loader [text]="'rentalPointsSelection.loading' | translate">
            <app-rental-points-selection [formId]="s.stepsData.rentalPointsSelection.id"/>
          </app-loader>
        }
        @case (s.stepsData.bikesSelection.step) {
          <app-loader [text]="'bikesSelection.loading' | translate">
            <app-bikes-selection [formId]="s.stepsData.bikesSelection.id"/>
          </app-loader>
        }
        @case (s.stepsData.accessoriesSelection.step) {
          <app-accessories-selection [formId]="s.stepsData.accessoriesSelection.id"/>
        }
        @case (s.stepsData.renterInfo.step) {
          <app-renter-info [formId]="s.stepsData.renterInfo.id"/>
        }
        @case (s.stepsData.termsAndConditions.step) {
          <app-terms-and-conditions [formId]="s.stepsData.termsAndConditions.id"/>
        }
        @case (s.stepsData.paymentSelection.step) {
          <app-payment-selection [formId]="s.stepsData.paymentSelection.id"/>
        }
        @case (s.stepsData.invoiceData.step) {
          <app-invoice-data [formId]="s.stepsData.invoiceData.id"/>
        }
        @case (s.stepsData.bookingHandler.step) {
          <app-booking-handler [formId]="s.stepsData.bookingHandler.id"/>
        }
        @default {
          <div class="k-display-flex k-justify-content-center">
            <strong style="color: var(--kendo-color-error)">
              Non-existent step {{ s.currentFormId() }}
            </strong>
          </div>
        }
      }
    }
  </section>
    @let hidePriceState = [
    s.stepsData.rentalPointsSelection.step,
    s.stepsData.termsAndConditions.step,
    s.stepsData.bookingHandler.step,
  ];
  @if (!hidePriceState.includes(s.currentStep()) && !hideBackButton) {
    <hr>
    <app-price-state/>
    <app-spacer/>
  }
  <div class="row">
    @if (!hideBackButton) {
      @if (s.currentStep() > 1 && !form().isReservation) {
        <button kendoButton themeColor="primary" size="large" fillMode="outline" (click)="back()"
          [disabled]="loaderService.isLoading()"
          [ngStyle]="{ width: s.currentStep() === s.stepsData.bookingHandler.step || s.currentStep() === s.stepsData.paymentSelection.step ? '100%' : '25%' }">
          {{ 'back' | translate }}
        </button>
      }
    }
    @if (s.currentStep() < s.stepsLength && s.currentStep() !== s.stepsData.paymentSelection.step) {
      <button kendoButton themeColor="primary" size="large" type="submit" style="width: 100%" (click)="next()"
        [disabled]="loaderService.isLoading()">
        {{ 'next' | translate }}
      </button>
    }
  </div>
  <app-spacer class="desktop"/>
  <app-footer/>
</div>

@if (showNoProductsDialog) {
  <kendo-dialog [title]="'attention' | translate">
    {{ 'error.itemsRequired' | translate }}
    <kendo-dialog-actions>
      <button kendoButton (click)="closeNoProductsDialog()" themeColor="primary">
        {{ 'close' | translate }}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
}

@if (showTestDataFiller) {
  <app-test-data/>
}
